export default "__VITE_ASSET__615446ad__"